import Http from '../util/Http';

class AdBannerApi {
    static async getBanners(slot) {
        const res = await Http.get(`/api/ad-banners?slot=${encodeURIComponent(slot)}`);
        return res || null;
    }

    static async getSlots() {
        const res = await Http.get('/api/admin/ad-banners/slots');
        return res || null;
    }

    static async listAdmin(slot = '') {
        const query = slot ? `?slot=${encodeURIComponent(slot)}` : '';
        const res = await Http.get(`/api/admin/ad-banners${query}`);
        return res || null;
    }

    static async create(data) {
        const res = await Http.post('/api/admin/ad-banners', data);
        return res || null;
    }

    static async update(bannerId, data) {
        const res = await Http.put(`/api/admin/ad-banners/${bannerId}`, data);
        return res || null;
    }

    static async remove(bannerId) {
        const res = await Http.delete(`/api/admin/ad-banners/${bannerId}`);
        return res || null;
    }
}

export default AdBannerApi;
